// extracted by mini-css-extract-plugin
export default {"card":"BuyAndSellStocksDesktop_card__Iq0t0","inCardContainer":"BuyAndSellStocksDesktop_inCardContainer__8p3MS"};